/**
 * Enum that contains the CI colors for formunauts
 */
export enum CIColors {
  Blue = '#0074C8',
}

/** Those are color variants only related to the rocket */
export type ColorVariant = 'white' | 'primary';
